import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {SessionService} from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private session: SessionService,
    private router: Router,
  ) {
  }

  canActivate(): boolean {
    if (this.session.hasAuthenticated()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }
}
